import { useNavigate } from 'react-router-dom';
import { useLocalization } from '../../contexts/LocalizationContext';
import { useAuth } from '../../contexts/AuthContext';

const Header = ({ onMenuToggle }) => {
  const { currentLanguage, setLanguage, isRtl } = useLocalization();
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="top-header">
      <div className="header-left">
        <button className="mobile-menu-toggle" onClick={onMenuToggle} type="button">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
        </button>

        <div className="search-box">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
          <input type="text" placeholder={isRtl ? 'بحث...' : 'Search...'} />
        </div>
      </div>

      <div className="header-right">
        <div className="lang-toggle-group">
          <button
            className={`lang-btn ${currentLanguage === 'en' ? 'active' : ''}`}
            onClick={() => setLanguage('en')}
          >
            EN
          </button>
          <button
            className={`lang-btn ${currentLanguage === 'ar' ? 'active' : ''}`}
            onClick={() => setLanguage('ar')}
          >
            ع
          </button>
        </div>

        <button className="header-btn header-btn-bell" title={isRtl ? 'الإشعارات' : 'Notifications'} onClick={() => navigate('/notifications')}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
            <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
          </svg>
        </button>

        <div className="user-avatar" title={user?.username || 'Admin'}>
          {user?.username?.[0]?.toUpperCase() || 'A'}
        </div>
      </div>
    </header>
  );
};

export default Header;
